
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.139","height":"13.486"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Archive","transform":"translate(-1579.98 -58.704)"}},[_c('path',{attrs:{"id":"Path_20604","data-name":"Path 20604","d":"M11.924 0H2.373a.775.775 0 00-.585.266L.7 1.509a2.861 2.861 0 00-.7 1.88v8a2.1 2.1 0 002.1 2.1h9.94a2.1 2.1 0 002.1-2.1V3.316a2.86 2.86 0 00-.621-1.781L12.53.293A.774.774 0 0011.924 0","transform":"translate(1579.98 58.704)","fill":"#6b7787"}}),_c('path',{attrs:{"id":"Path_20605","data-name":"Path 20605","d":"M14.57 2.6l-.793-1.47H4.332L3.4 2.6","transform":"translate(1578.065 58.134)","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_20606","data-name":"Path 20606","d":"M12.486 10.695H10.8V8.567a.322.322 0 00-.322-.322H8.471a.322.322 0 00-.322.322v2.128H6.468a.222.222 0 00-.144.391l3.009 2.69a.222.222 0 00.288 0l3.008-2.69a.222.222 0 00-.144-.391","transform":"translate(1577.573 55.236)","fill":"#fff"}})])])
          )
        }
      }
    